import { getLanguages } from '@/constants/languages';

const languages = getLanguages();

export const LanguageFormatter = (val) => {
  return languages.find((lang) => lang.lang === val)?.value;
};
